module.exports = __webpack_public_path__ + "static/img/monitiornew6.b63137ff.png";